




















































// vue
import {
    computed,
    defineComponent,
    onMounted,
    ref,
} from '@vue/composition-api';

// hooks
import { useStore } from '@/store';

// models
import { Event } from '@/vue3/api/models';

// primevue
import Listbox from 'primevue/listbox';
import ProgressSpinner from 'primevue/progressspinner';
import Button from 'primevue/button';

// service
import { useService } from '@/vue3/api/services';

// components
import EditorDropdown from '@/vue3/components/editor/EditorDropdown.vue';

export default defineComponent({
    components: {
        Listbox,
        ProgressSpinner,
        Button,
        EditorDropdown,
    },
    props: {
        geoRecord: {
            type: Object,
            default: () => {},
        },
        handleGeoRecordPropertyUpdate: {
            type: Function,
            default: () => {},
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        isMobile: {
            type: Boolean,
            default: false,
        },
    },
    setup(props: any) {
        // hooks
        const { getters } = useStore();

        // services
        const { getAllArchiveEvents } = useService();

        // reactive
        const events = ref<Event[]>([]);

        // computed
        const eventSelected = computed(() => {
            if (events.value) {
                return events.value.find(
                    (event) => event.id == props.geoRecord.archiveEventId,
                );
            }
            return null;
        });

        // methods
        const refreshEvents = async () => {
            events.value = await getAllArchiveEvents();
            if (events.value == null) {
                events.value = [
                    {
                        id: 0,
                        name: 'None',
                        organizationId: getters.currentOrganization.id,
                        iconFileName: '',
                    },
                ];
            }

            events.value = events.value.filter(
                (project, index, self) =>
                    index === self.findIndex((t) => t.name === project.name),
            );
        };

        // lifecycle
        onMounted(async () => {
            await refreshEvents();
        });

        return {
            events,
            eventSelected,
        };
    },
});
